import { Navigate, Route, Routes } from "react-router-dom";
import AdminShell from "./admin/AdminShell";
import AdminAuthRoot, { SignInRoute, SignUpRoute } from "./admin/auth/AdminAuth";
import CapturesPage from "./admin/CapturesPage";
import Dashboard from "./admin/Dashboard";
import DemoEditor from "./admin/DemoEditor";
import NewProductWizard from "./admin/NewProductWizard";
import ProductPage from "./admin/ProductPage";
import PublicPlayer from "./player/PublicPlayer";

export default function App() {
  return (
    <Routes>
      <Route element={<AdminAuthRoot />}>
        <Route path="/admin/login/*" element={<SignInRoute />} />
        <Route path="/admin/sign-up/*" element={<SignUpRoute />} />
        <Route path="/admin" element={<AdminShell />}>
          <Route index element={<Dashboard />} />
          <Route path="new" element={<NewProductWizard />} />
          <Route path="captures" element={<CapturesPage />} />
          <Route path="products/:productId" element={<ProductPage />} />
          <Route path="demos/:demoId" element={<Navigate to="basics" replace />} />
          <Route path="demos/:demoId/:tab" element={<DemoEditor />} />
        </Route>
      </Route>
      <Route path="/:productSlug/:demoSlug" element={<PublicPlayer />} />
      <Route path="*" element={<div className="center-msg"><p>Nothing here. If you were sent a demo link, check that it was copied in full.</p></div>} />
    </Routes>
  );
}
